const user = () => import(/* webpackPrefetch: true */ '@/views/private/setting/user/index.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/user/edit/_id.vue')

const wallpaper = () => import(/* webpackPrefetch: true */ '@/views/private/setting/wallpaper/index.vue')

const company = () => import(/* webpackPrefetch: true */ '@/views/private/setting/company/index.vue')

const master = () => import(/* webpackPrefetch: true */ '@/views/private/setting/master/index.vue')
const master_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/master/add/index.vue')
const master_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/master/edit/_id.vue')

const food_category = () => import(/* webpackPrefetch: true */ '@/views/private/setting/food/index.vue')
const food_category_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/food/add/index.vue')
const food_category_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/food/edit/_id.vue')

const channel_category = () => import(/* webpackPrefetch: true */ '@/views/private/setting/channel/index.vue')
const channel_category_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/channel/add/index.vue')
const channel_category_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/channel/edit/_id.vue')

const app = () => import(/* webpackPrefetch: true */ '@/views/private/setting/app/index.vue')
const app_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/app/add/index.vue')
const app_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/app/edit/_id.vue')

const screensaver = () => import(/* webpackPrefetch: true */ '@/views/private/setting/screensaver/index.vue')
const screensaver_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/screensaver/add/index.vue')
const screensaver_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/screensaver/edit/_id.vue')

const promo = () => import(/* webpackPrefetch: true */ '@/views/private/setting/promo/index.vue')
const promo_add = () => import(/* webpackPrefetch: true */ '@/views/private/setting/promo/add/index.vue')
const promo_edit = () => import(/* webpackPrefetch: true */ '@/views/private/setting/promo/edit/_id.vue')


const routes = [
  {
    path: "/setting/user",
    name: "User",
    component: user,
    meta: {
      title: "User"
    }
  },
  {
    path: "/setting/user/add",
    name: "User Add",
    component: user_add,
    meta: {
      title: "User Add"
    }
  },
  {
    path: "/setting/user/edit/:id",
    name: "User Edit",
    component: user_edit,
    meta: {
      title: "User Edit"
    }
  },


  {
    path: "/setting/wallpaper",
    name: "Wallpaper",
    component: wallpaper,
    meta: {
      title: "Wallpaper"
    }
  },


  {
    path: "/setting/company",
    name: "Company",
    component: company,
    meta: {
      title: "Company"
    }
  },


  {
    path: "/setting/foodcategory",
    name: "Food Category",
    component: food_category,
    meta: {
      title: "Food Category"
    }
  },
  {
    path: "/setting/foodcategory/add",
    name: "Food Category Add",
    component: food_category_add,
    meta: {
      title: "Food Category Add"
    }
  },
  {
    path: "/setting/foodcategory/edit/:id",
    name: "Food Category Edit",
    component: food_category_edit,
    meta: {
      title: "Food Category Edit"
    }
  },


  {
    path: "/setting/channelcategory",
    name: "Channel Category",
    component: channel_category,
    meta: {
      title: "Channel Category"
    }
  },
  {
    path: "/setting/channelcategory/add",
    name: "Channel Category Add",
    component: channel_category_add,
    meta: {
      title: "Channel Category Add"
    }
  },
  {
    path: "/setting/channelcategory/edit/:id",
    name: "Channel Category Edit",
    component: channel_category_edit,
    meta: {
      title: "Channel Category Edit"
    }
  },


  {
    path: "/setting/master",
    name: "Master Room",
    component: master,
    meta: {
      title: "Master Room"
    }
  },
  {
    path: "/setting/master/add",
    name: "Master Room Add",
    component: master_add,
    meta: {
      title: "Master Room Add"
    }
  },
  {
    path: "/setting/master/edit/:id",
    name: "Master Room Edit",
    component: master_edit,
    meta: {
      title: "Master Room Edit"
    }
  },


  {
    path: "/setting/app",
    name: "App In App",
    component: app,
    meta: {
      title: "App In App"
    }
  },
  {
    path: "/setting/app/add",
    name: "App In App Add",
    component: app_add,
    meta: {
      title: "App In App Add"
    }
  },
  {
    path: "/setting/app/edit/:id",
    name: "App In App Edit",
    component: app_edit,
    meta: {
      title: "App In App Edit"
    }
  },


  {
    path: "/setting/screensaver",
    name: "Screensaver",
    component: screensaver,
    meta: {
      title: "Screensaver"
    }
  },
  {
    path: "/setting/screensaver/add",
    name: "App Screensaver Add",
    component: screensaver_add,
    meta: {
      title: "App Screensaver Add"
    }
  },
  {
    path: "/setting/screensaver/edit/:id",
    name: "App Screensaver Edit",
    component: screensaver_edit,
    meta: {
      title: "App Screensaver Edit"
    }
  },


  {
    path: "/setting/promo",
    name: "Promo",
    component: promo,
    meta: {
      title: "Promo"
    }
  },
  {
    path: "/setting/promo/add",
    name: "App Promo Add",
    component: promo_add,
    meta: {
      title: "App Promo Add"
    }
  },
  {
    path: "/setting/promo/edit/:id",
    name: "App Promo Edit",
    component: promo_edit,
    meta: {
      title: "App Promo Edit"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})